export default __webpack_public_path__ + "static/media/background.770794a3.png";